import request from '@/utils/request'


// 登录方法
export function getJsapiSignature(pageUrl) {
  return request({
    url: '/wechat/wxauth/noauth/createJsapiSignature?pageUrl='+pageUrl,
    method: 'get',
  })
}
//创建订单
export function createPaperOrder (obj) {
  return request({
    url: '/wechat/wxPay/createPaperOrder',
    method: 'post',
    data: obj
  })
}